// Date utilities for consistent date handling across the app

export const getCurrentYear = () => 2025
export const getNextYear = () => 2026

// Generate realistic dates for campaigns and deliverables
export const generateCampaignDates = () => {
  const now = new Date()
  const currentMonth = now.getMonth()
  const currentYear = getCurrentYear()

  return {
    // Active campaigns - deadlines in next 1-3 months
    activeDeadline1: `${currentYear}-${String(currentMonth + 2).padStart(2, '0')}-15`,
    activeDeadline2: `${currentYear}-${String(currentMonth + 3).padStart(2, '0')}-01`,
    activeDeadline3: `${currentYear}-${String(currentMonth + 2).padStart(2, '0')}-20`,

    // Planning campaigns - deadlines in 3-6 months
    planningDeadline1: `${currentYear}-${String(currentMonth + 4).padStart(2, '0')}-01`,
    planningDeadline2: `${currentYear}-${String(currentMonth + 5).padStart(2, '0')}-15`,

    // Completed campaigns - past dates
    completedDeadline1: `${currentYear}-${String(currentMonth).padStart(2, '0')}-30`,
    completedDeadline2: `${currentYear}-${String(currentMonth - 1).padStart(2, '0')}-20`,

    // Deliverable deadlines - spread across next 2 months
    deliverableDeadline1: `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-10`,
    deliverableDeadline2: `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-12`,
    deliverableDeadline3: `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-14`,
    deliverableDeadline4: `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-13`,
    deliverableDeadline5: `${currentYear}-${String(currentMonth + 2).padStart(2, '0')}-20`,
    deliverableDeadline6: `${currentYear}-${String(currentMonth + 2).padStart(2, '0')}-22`,

    // Task deadlines
    taskDeadline1: `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-12`,
    taskDeadline2: `${currentYear}-${String(currentMonth + 2).padStart(2, '0')}-20`,
    taskDeadline3: `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-15`,
    taskDeadline4: `${currentYear}-${String(currentMonth + 2).padStart(2, '0')}-25`,
    taskDeadline5: `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-10`,
    taskDeadline6: `${currentYear}-${String(currentMonth + 2).padStart(2, '0')}-18`,

    // Joined/Created dates
    joinedDate1: `${currentYear - 2}-01-15`,
    joinedDate2: `${currentYear - 2}-03-20`,
    createdDate1: `${currentYear}-${String(currentMonth).padStart(2, '0')}-01`,
    createdDate2: `${currentYear}-${String(currentMonth).padStart(2, '0')}-05`,
    createdDate3: `${currentYear}-${String(currentMonth).padStart(2, '0')}-03`,
    createdDate4: `${currentYear}-${String(currentMonth).padStart(2, '0')}-02`,
    createdDate5: `${currentYear}-${String(currentMonth - 1).padStart(2, '0')}-28`,
    createdDate6: `${currentYear}-${String(currentMonth).padStart(2, '0')}-06`,

    // Last contact dates
    lastContact1: `${currentYear}-${String(currentMonth).padStart(2, '0')}-${String(now.getDate() - 2).padStart(2, '0')}`,
    lastContact2: `${currentYear}-${String(currentMonth).padStart(2, '0')}-${String(now.getDate() - 7).padStart(2, '0')}`,
    lastContact3: `${currentYear}-${String(currentMonth).padStart(2, '0')}-${String(now.getDate() - 3).padStart(2, '0')}`,
    lastContact4: `${currentYear}-${String(currentMonth - 2).padStart(2, '0')}-15`,

    // Collaboration dates
    lastCollaboration1: `${currentYear}-${String(currentMonth).padStart(2, '0')}-01`,
    lastCollaboration2: `${currentYear}-${String(currentMonth - 1).padStart(2, '0')}-15`,
    lastCollaboration3: `${currentYear}-${String(currentMonth - 2).padStart(2, '0')}-20`,
  }
}

export const dates = generateCampaignDates()

// Format date for display
export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

// Calculate days until deadline
export const daysUntilDeadline = (deadline: string) => {
  return Math.ceil(
    (new Date(deadline).getTime() - new Date().getTime()) / (1000 * 3600 * 24),
  )
}
